import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion'; // For adaptive list animations
import { useKernel } from '../hooks/AIKernel'; // The Symbolic Engine
import ListItem from './ListItem';
import './UrlList.css';

const UrlList = ({ shortenedLinkList }) => {
  // --- AI Kernel Integration ---
  const { agentState, reportBehavior } = useKernel();

  // 🧠 AI Sensor: Track when the user builds a large list of links
  useEffect(() => {
    if (shortenedLinkList.length >= 5) {
      // User is highly active and managing multiple links
      reportBehavior('power_user_dashboard', 2, 'interest');
    }
  }, [shortenedLinkList.length, reportBehavior]);

  // We reverse the array here directly during render (modern React pattern)
  // We use the spread operator [...] so we don't mutate the original props array
  const displayList = [...shortenedLinkList].reverse();

  return (
    // Apply the dynamic AI theme to the container
    <div className={`link-list-container ${agentState.theme}`}>
      {shortenedLinkList.length > 0 && <div className="link-list-header" aria-hidden="true">
        <div className="link-header table-headings">
          LINK
        </div>
        <div className="visits-header table-headings">
          VISITS
        </div>
        <div className="last-visited-header table-headings">
          LAST VISITED
        </div>
      </div>}

      {displayList.length === 0 ? (
        <p className="link-list-empty">Your new links will appear here.</p>
      ) : (
        <motion.ul className="link-history" layout>
          <AnimatePresence>
            {displayList.map((tmpLinkItem) => (
              <motion.li
                key={tmpLinkItem.shortcode}
                layout
                initial={agentState.ui.simplifyAnimations ? { opacity: 1 } : { opacity: 0, y: -12 }}
                animate={{ opacity: 1, y: 0 }}
                exit={agentState.ui.simplifyAnimations ? { opacity: 0 } : { opacity: 0, scale: 0.98, height: 0 }}
                transition={{ duration: agentState.ui.simplifyAnimations ? 0 : 0.22 }}
              >
                <ListItem
                  shortLinkIdentifier={tmpLinkItem.shortcode}
                  originalLink={tmpLinkItem.originalLink}
                  visits={tmpLinkItem.visits}
                  lastVisited={tmpLinkItem.lastVisited}
                />
              </motion.li>
            ))}
          </AnimatePresence>
        </motion.ul>
      )}

    </div>
  );
};

export default UrlList;